<!--  -->
<template>
  <div id="main" class="padd60">
    <div ref="top" class="top">
      <div class="top-container" id="top-container">
        <div>
          <div>关于我们</div>
          <div>
            北京国科恒通科技股份有限公司成立于2006年，是一家位于中关村科技园的高新和双软企业，其核心成员源于清华大学，现已成为业界专业的电网GIS、数字电网、增量配电网和综合能源服务领域解决方案提供商。
          </div>
        </div>
      </div>
    </div>
    <div ref="tabs" class="nav">
      <div class="nav_list" :class="{ isFixed: isFixed }">
        <ul class="nav_ul">
          <li
            v-for="(item, tabIndex) in tabs"
            :key="tabIndex"
            class="nav_li"
            :class="{ navActive: activeIndex === tabIndex }"
            @click="tabClick(tabIndex, item.ref)"
          >
            {{ item.name }}
          </li>
        </ul>
      </div>
    </div>
    <div ref="overview" class="overview">
      <div id="about-us">
        <div>
          <div>关于国科恒通</div>
          <div>
            <p>
              北京国科恒通科技股份有限公司成立于2006年，是一家位于中关村科技园的高新和双软企业，其核心成员源于清华大学，现已成为业界专业的电网GIS、数字电网、增量配电网和综合能源服务领域解决方案提供商。
            </p>
            <p>
              国科恒通拥有50余项软著及多项发明专利，拥有信息系统集成及服务资质三级、CMMI3级认证、ISO9001:2008质量管理体系、ISO20000信息技术服务管理体系认证等。
            </p>
            <p>
              主营产品包括基于GIS的能源网资源管理系统、IoT能源大数据平台、电网数字化与智能化应用、增量配电网运营管控一体化应用系统以及综合智慧能源服务平台等，助力电网和综合能源系统的精益化管理，与客户共同打造数字化、智慧化的电网运营和综合能源服务新业态。
            </p>
            <p>
              秉承清华大学“厚德载物，自强不息”的精神，国科恒通持之以恒的将科技成果转化成为稳定可靠的软件产品与系统，为客户提供高质量的信息化与自动化融合，业务应用和管理深度完美融合的能源数字化与智能化整体解决方案和服务。
            </p>
          </div>
        </div>
        <img src="../../assets/image/aboutus-icon7.png" alt="" />
      </div>
    </div>
    <div ref="framework" class="framework">
      <div id="corporate-culture">
        <div>
          <div>企业文化</div>
          <div>
            <div>
              <div>
                <img src="../../assets/image/aboutus-icon4.png" alt="" />
                <div>价值观</div>
              </div>
              <div>胸怀远大理想、专注技术创新、共创美好未来</div>
            </div>
            <div>
              <div>
                <img src="../../assets/image/aboutus-icon5.png" alt="" />
                <div>使命</div>
              </div>
              <div>
                我们要有成为伟大企业的决心、我们要让国科成为所有人追求成功的平台、我们国科人同呼吸、共命运、风雨与共
              </div>
            </div>
            <div>
              <div>
                <img src="../../assets/image/aboutus-icon8.png" alt="" />
                <div>愿景</div>
              </div>
              <div>致力于成为领先的能源数字化与智能化整体解决方案和服务商</div>
            </div>
            <div>
              <div>
                <img src="../../assets/image/aboutus-icon9.png" alt="" />
                <div>战略</div>
              </div>
              <div>共建能源互联生态、同享美好绿色生活</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div ref="customer" class="customer">
      <div id="development-history">
        <div>
          <div>发展历程</div>
          <div>
            <div v-for="(item, index) in historyList" :key="index" class="item">
              <div>{{ item.time }}</div>
              <div class="circle">
                <div></div>
              </div>
              <div>
                <span>{{ item.text }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div ref="innovate" class="innovate">
      <!-- <h3 style="height: 1px;"></h3> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'AboutUs',
  components: {},
  data() {
    return {
      initListArr: [], // 计算滚动高亮高度
      activeName: 'overview',
      index: 0,
      isFixed: false, // 是否fixed
      tabs: [
        { name: '关于国科恒通', ref: 'overview' },
        { name: '企业文化', ref: 'framework' },
        { name: '发展历程', ref: 'customer' },
        { name: '联系我们', ref: 'innovate' },
      ],
      productList: [
        {
          title: '增量配电网运营管控一体化应用系统',
          logo: require('@/assets/product/productLogo1.svg'),
          describe:
            '支撑配电网设备资产管理、生产运检、调度管理、营销服务以及综合能源增值服务等全业务的开展，提升配电网的投资效率、能源效率和管理效率。',
        },
        {
          title: '电网数字化与智能化应用',
          logo: require('@/assets/product/productLogo2.svg'),
          describe:
            '涵盖发、输、变、配、用能全流程，覆盖规划、采购、运行、检修供应链全环节，支撑调度运行、经营管理等全业务域的统一数字电网模型。',
        },
        {
          title: '综合智慧能源服务平台',
          logo: require('@/assets/product/productLogo3.svg'),
          describe:
            '为单个、多个、区域和跨区等多样化的客户，提供安全、经济、清洁、高效、开放、共享特征的综合智慧能源服务系统。',
        },
      ],
      productList2: [
        {
          title: '基于GIS的能源网资源管理系统',
          logo: require('@/assets/product/productLogo4.svg'),
          describe:
            '具有强大的能源网构建、时空数据管理、能源查询和分析、多维数据融合和可视化演示、业务集成应用支撑以及面向桌面、大屏、WEB、移动多端应用开发的全面支持能力。',
        },
        {
          title: '电网数字化与智能化应用',
          logo: require('@/assets/product/productLogo5.svg'),
          describe:
            '基于“物”模型的物联设备管理。利用“产品-服务”的物模型定义和管理，实现快速、批量管理大量采集装置，并实现远程配置与升级等。',
        },
      ],
      activeIndex: 0,
      historyList: [
        { time: '2021年', text: '砥砺前行' },
        {
          time: '2020年',
          text: '西电集团综合能源管控与服务平台陕西地电电网数字化运行平台'
        },
        { time: '2019年', text: '南方电网海南数字电网示范项目' },
        {
          time: '2018年',
          text:
            '综合智慧能源服务平台IOT能源大数据平台成功应用于珠海横琴国家级互联网+智慧能源示范项目',
        },
        { time: '2017年', text: '深圳前海增量配电网试点项目' },
        { time: '2016年', text: '整体改制布局新业务' },
        {
          time: '2015年',
          text: '面向高可靠性的配电网规划决策软件获国家电网公司推广',
        },
        {
          time: '2014年',
          text: '电网GIS平台产品支撑中国南方电网信息化建设与应用',
        },
        {
          time: '2013年',
          text: '城乡智能配电网辅助决策平台获贵州省科技厅立项',
        },
        {
          time: '2012年',
          text: '面向可靠性和故障自愈的智能配电网辅助规划系统研发成功',
        },
        { time: '2011年', text: '浙江电力电网GIS平台率先上线运行' },
        {
          time: '2010年',
          text: '面向省级集中部署多级应用的电网GIS空间信息服务平台研发成功',
        },
        {
          time: '2009年',
          text:
            '基于数字化电网的突发性灾害实时监测预警及响应系统获科委立项支持',
        },
        { time: '2008年', text: 'GIS平台为北京奥运保驾护航' },
        { time: '2007年', text: '地县一体化电网资源管理系统研发成功' },
        { time: '2006年', text: '扬帆起航' },
      ],
    }
  },
  computed: {},
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.getHeight()
    })

    this.tabsHeight = this.$refs.tabs.offsetHeight
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    /** 滚动事件 */
    handleScroll() {
      this.getHeight()
      this.isScroll = true
      // 获取页面滚动条的高度
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      this.scrollTop = scrollTop
      const offsetTop = this.getOffsetTop(this.$refs.tabs)
      this.isFixed = scrollTop > offsetTop // 是否固定
      if (!this.isScroll) return
      // 滚动高亮
      const [block1, block2, block3, block4] = this.initListArr
      if (scrollTop < block1) {
        this.activeIndex = ''
      } else if (block1 <= scrollTop && scrollTop < block2) {
        this.activeIndex = 0
      } else if (block2 < scrollTop && scrollTop < block3) {
        this.activeIndex = 1
      } else if (block3 < scrollTop && scrollTop < block4) {
        this.activeIndex = 2
      } else if (scrollTop > block4) {
        this.activeIndex = 3
      }
    },
    getOffsetTop(obj) {
      let offsetTop = 0
      while (obj != window.document.body && obj != null) {
        offsetTop += obj.offsetTop
        obj = obj.offsetParent
      }
      return offsetTop
    },
    getHeight() {
      let initTop = this.$refs.overview.offsetTop - 20
      this.initListArr = []
      this.tabs.forEach((item) => {
        const elem = this.$refs[item.ref]
        const blockHeight = parseInt(
          window.getComputedStyle(elem, null)['height']
        )
        this.initListArr.push(initTop)
        initTop = initTop + blockHeight - 50 // 偏移距离30
      })
    },
    tabClick(index, ref) {
      // 点击高亮滚动
      // 获取当前选中的index以便后面滚动高亮
      this.activeIndex = parseInt(index)
      this.activeName = ref
      // 给定一个标识，锚点事件不触发滚动
      this.isScroll = false
      this.isChange = false
      // 获取当前选中元素的top值（给元素绑定对应的ref值）
      const offsetTop = this.getOffsetTop(this.$refs[ref])
      const scrollTop = offsetTop - this.$refs['tabs'].offsetHeight
      // 获取当前位置方法
      const currentY =
        document.documentElement.scrollTop || document.body.scrollTop
      this.scrollAnimation(currentY, scrollTop)
    },
    // 滚动
    scrollAnimation(currentY, targetY) {
      this.isScroll = true
      // 计算需要移动的距离
      const needScrollTop = targetY - currentY
      let _currentY = currentY
      setTimeout(() => {
        const dist = Math.ceil(needScrollTop / 10)
        _currentY += dist
        window.scrollTo(_currentY, currentY)
        if (needScrollTop > 10 || needScrollTop < -10) {
          this.scrollAnimation(_currentY, targetY)
        } else {
          this.isScroll = false
          window.scrollTo(_currentY, targetY)
        }
      })
    },
  },
}
</script>
<style scoped lang="less">
.top {
  width: 100%;
  position: relative;
  font-size: 13px;
  > img {
    width: 100%;
    height: 100%;
  }
  .title {
    position: absolute;
    top: 30%;
    width: 40%;
    transform: translate(35%, 0);
    > h3 {
      height: 40px;
      line-height: 40px;
      color: #fff;
      font-size: 25px;
      margin-bottom: 5px;
    }
    > div {
      line-height: 23px;
      letter-spacing: 1px;
      color: #d8d9da;
    }
  }
}
.nav {
  .isFixed {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 99999;
    background: #f5f5f9;
  }
  width: 100%;
  background: #f5f5f9;
  height: 40px;
  display: flex;
  align-items: center;
  .nav_list {
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: center;
    .nav_ul {
      display: flex;
      font-size: 14px;
      .nav_li {
        font-size: 0.14rem;
        height: 40px;
        line-height: 40px;
        margin-right: 10px;
        cursor: pointer;
        padding: 0 8px;
        &.navActive {
          color: #f1bd1c;
          border-bottom: 2px solid #f1bd1c;
        }
      }
    }
  }
}
.overview {
  background: #fff;
  > h3 {
    height: 50px;
    line-height: 50px;
    font-size: 25px;
    text-align: center;
    padding: 20px 0;
  }
  .product_wrap {
    width: 80%;
    margin: 0 auto;
    font-family: 'PingFangSC-Medium';
    .product_list {
      &.product_list2 {
      }
      margin-bottom: 30px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .product_li {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border: 1px solid #dedede;
        border-radius: 4px;
        margin-right: 3%;
        .li_logo {
          margin: 20px 0;
          text-align: center;
          > img {
            width: 38px;
          }
        }
        .li_title {
          margin: 15px 8px;
          color: #261e1c;
          font-size: 16px;
          font-weight: bold;
        }
        .li_describe {
          margin: 10px 12px;
          font-size: 14px;
          color: #261e1c;
        }
        .li_link {
          margin: 20px 0;
          display: flex;
          color: #f1bd1c;
          align-items: center;
          cursor: pointer;
          > img {
            margin-left: 5px;
            width: 20px;
          }
        }
      }
    }
  }
}
.framework {
  background-size: cover;
  > h3 {
    color: #fff;
    height: 50px;
    line-height: 50px;
    font-size: 25px;
    text-align: center;
    padding: 20px 0;
  }
  .image {
    width: 80%;
    margin: 20px auto 0;
    padding-bottom: 30px;
    text-align: center;
    > img {
      width: 100%;
    }
  }
}

.customer {
  background: #f8f8f9;
  overflow: hidden;
  > h3 {
    height: 50px;
    line-height: 50px;
    font-size: 25px;
    text-align: center;
    padding: 20px 0;
  }
  .wrap {
    width: 80%;
    margin: 20px auto;
    .customer_ul {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      .customer_li {
        height: 110px;
        line-height: 110px;
        text-align: center;
        margin: 0 5px 15px 15px;
        > img {
          width: 180px;
        }
      }
    }
  }
}

.innovate {
  background: #fff;
  background-size: bottom 20%;
  > h3 {
    height: 50px;
    line-height: 50px;
    font-size: 25px;
    text-align: center;
    padding: 20px 0;
  }
  .wrap {
    width: 80%;
    margin: 0 auto;
    .innovate_ul {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-flow: wrap;
      .innovate_li {
        width: 33.3%;
        display: flex;
        flex-direction: column;
        margin-bottom: 40px;
        .number {
          color: #fcb01e;
          font-size: 22px;
          font-weight: bold;
          letter-spacing: 1px;
          margin-bottom: 5px;
        }
        .content {
          color: #261e1c;
          font-size: 14px;
        }
      }
    }
  }
}

.list {
  margin-top: 10px;
  .list-title {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    > span {
      font-size: 22px;
      font-weight: bold;
    }
    .line {
      margin-top: 10px;
      height: 3px;
      width: 60px;
      background: #f1bd1c;
    }
    .message {
      width: 80%;
      margin: 20px;
      font-size: 14px;
      text-align: center;
    }
  }
}
.swiper-content {
  width: 99%;
  margin: 50px auto;
  min-height: 500px;
  .swiper-container {
    position: relative;
    width: 100%;
    height: 100%;
    .swiper-slide {
      cursor: pointer;
      .list-logo {
        text-align: center;
        > img {
          width: 100%;
        }
      }
      .list-title {
        width: 100%;
        font-size: 20px;
        font-weight: bold;
        height: 55px;
        line-height: 55px;
        color: #333;
        text-align: center;
      }
      .list-describe {
        width: 100%;
        line-height: 25px;
        color: #777570;
        max-height: 230px;
        overflow: auto;
        font-size: 13px;
      }
      .list-productname {
        margin-top: 15px;
        display: flex;
        > span {
          width: 80px;
          color: #777570;
          font-size: 13px;
        }
        > label {
          margin-left: 3px;
          flex: 1;
          font-size: 13px;
        }
      }
      .list-customer {
        margin-top: 15px;
        display: flex;
        align-items: center;
        > span {
          width: 80px;
          color: #777570;
          font-size: 13px;
        }
        > img {
          margin-left: 3px;
          width: 80px;
        }
      }
    }
  }
}
@media screen and (max-width: 639px) {
  #main {
    .top {
      .title {
        width: 90%;
        top: 23%;
        transform: translate(5%, 0);
        > h3 {
          height: 30px;
          line-height: 30px;
          font-size: 16px;
        }
        > div {
          font-size: 12px;
        }
      }
    }
  }
}
</style>
<style scoped lang="less">
.padd60 {
  position: relative;
  background: linear-gradient(360deg, #fcfcfc 0%, #f7f5f4 100%);
}
.top-container {
  box-sizing: border-box;
  padding-top: 2.04rem;
  height: 6.74rem;
  background: url('../../assets/image/banner.png') no-repeat;
  background-size: cover;
  & > div {
    margin-left: 3.6rem;
    & > div:first-child {
      font-size: 0.48rem;
      font-weight: 500;
      color: #ffffff;
      margin-bottom: 0.28rem;
    }
    & > div:last-child {
      width: 6rem;
      font-size: 0.16rem;
      font-weight: 400;
      color: #ffffff;
      margin-bottom: 0.28rem;
      line-height: 0.26rem;
    }
  }
}
#about-us {
  position: relative;
  // height: 5.6rem;
  padding: 0.4rem 0.2rem;
  background: #fff url('../../assets/image/aboutus-icon10.png') no-repeat;
  background-size: 30% 35%;
  background-position: 0 0;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    position: absolute;
    right: 0;
    top: 0;
    width: 2.3rem;
    height: 100%;
  }
  & > div {
    width: 11rem;
    & > div {
      display: flex;
      justify-content: center;
      color: #261e1c;
    }
    & > div:first-child {
      font-size: 0.32rem;
      font-weight: 500;
      margin-bottom: 0.63rem;
    }
    & > div:last-child {
      flex-direction: column;
      p {
        margin-bottom: 0.26rem;
        font-size: 0.16rem;
        line-height: 1.2;
      }
    }
  }
}
#corporate-culture {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-bottom: 0.5rem;
  margin-top: 0.4rem;
  & > div {
    width: 12rem;
    & > div:first-child {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 0.32rem;
      font-weight: 500;
      color: #261e1c;
      margin-bottom: 0.6rem;
    }
    & > div:last-child {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      & > div {
        width: 5.8rem;
        height: 1.6rem;
        background: #ffffff;
        margin-bottom: 0.2rem;
        box-sizing: border-box;
        padding-top: 0.35rem;
        padding-left: 0.35rem;
        & > div:first-child {
          display: flex;
          align-items: center;
          font-size: 0.2rem;
          font-weight: 500;
          color: #261e1c;
          img {
            width: 0.24rem;
            height: 0.24rem;
            margin-right: 0.1rem;
          }
        }
        & > div:last-child {
          font-size: 0.16rem;
          font-weight: 400;
          color: #261e1c;
          margin-top: 0.15rem;
        }
      }
    }
  }
}
#development-history {
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  & > div {
    width: 12rem;
    & > div:first-child {
      display: flex;
      justify-content: center;
      font-size: 0.32rem;
      font-weight: 500;
      color: #261e1c;
      margin: 0.6rem 0;
    }
    & > div:last-child {
      & > div {
        display: flex;
      }
    }
    .item {
      & > div:first-child {
        width: 1rem;
        font-size: 0.2rem;
        font-weight: 500;
        color: #261e1c;
      }
      .circle {
        position: relative;
        width: 0.24rem;
        height: 0.24rem;
        box-sizing: border-box;
        background: #fff;
        padding: 0.05rem;
        border: 0.01rem solid #fcb01e;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 0.84rem 0 0.43rem;
        div {
          width: 100%;
          height: 100%;
          border-radius: 50%;
          background: #fcb01e;
        }
      }
      .circle::after {
        position: absolute;
        top: 0.24rem;
        left: 0.08rem;
        content: '';
        width: 0.01rem;
        height: 0.6rem;
        background: #fcb01e;
      }

      & > div:last-child {
       display: flex;
    align-items: center;
    position: relative;
    box-sizing: border-box;
    width: 10rem;
    padding: .2rem 0;
    /* height: 0.52rem; */
    background: #f7f5f4;
    margin-bottom: 0.32rem;
    /* line-height: 0.52rem; */
    padding-left: 0.56rem;
    font-size: 0.16rem;
    font-weight: 400;
    color: #261e1c;
        .sanjiao {
          position: absolute;
        }
      }
      & > div:last-child:before {
        content: '';
        position: absolute;
        right: 100%;
        top: 0.02rem;
        width: 0;
        height: 0;
        border-width: 0.08rem;
        border-style: solid;
        border-color: transparent;
        margin-bottom: 0.1rem;
        border-right-width: 0.16rem;
        border-right-color: currentColor;
        color: #f7f5f4;
      }
    }
    .item:last-child {
      .circle::after {
        display: none;
      }
    }
  }
}
@media screen and (max-width: 639px) {
  .top-container {
    & > div {
      & > div:last-child {
        width: 95%;
        line-height: 1.2;
      }
    }
  }
  #corporate-culture {
    & > div {
      & > div:last-child {
        & > div {
          width: 100%;
          height: auto;
          background: #ffffff;
          margin-bottom: 0.2rem;
          box-sizing: border-box;
          padding: 0.35rem;
          & > div:first-child {
            img {
              width: 0.5rem;
              height: 0.5rem;
              margin-right: 0.1rem;
            }
          }
        }
      }
    }
  }
  #development-history {
 
  & > div {
    & > div:first-child {
      
    }
    & > div:last-child {
      & > div {
      }
    }
    .item {
      & > div:first-child {
        width: 2.6rem;
        font-size: 0.2rem;
        font-weight: 500;
        color: #261e1c;
      }
    }
  }
}
}
</style>
